import React from "react";
import { useNavigate } from "react-router-dom";
import { Lock, KeyRound } from "lucide-react";

export default function AmazonPending() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-app flex items-center justify-center px-5 relative" data-testid="amazon-pending-page">
      <div className="absolute inset-0 hud-grid opacity-20" />
      <div className="relative glass-strong clip-chamfer brackets p-10 max-w-md w-full text-center">
        <div className="w-16 h-16 mx-auto border border-amber/50 flex items-center justify-center box-glow-amber">
          <KeyRound className="w-7 h-7 text-amber" />
        </div>
        <h1 className="font-head text-2xl uppercase font-bold mt-5 text-amber">Amazon Pay — Setup Required</h1>
        <p className="text-slate-400 mt-3 text-sm leading-relaxed">
          Your order is saved on your account as pending. Completing live Amazon Pay charges
          requires merchant credentials (Merchant ID, Store ID, Public Key ID, private key).
          Provide them to activate Amazon Pay, or use Stripe in the meantime.
        </p>
        <div className="flex gap-3 mt-7">
          <button onClick={() => navigate("/shop/checkout")} className="btn-hud flex-1 border border-cyan text-cyan py-3 text-sm hover:bg-cyan hover:text-app">
            Use Stripe
          </button>
          <button onClick={() => navigate("/shop")} className="btn-hud flex-1 border border-white/15 text-slate-300 py-3 text-sm hover:border-amber hover:text-amber">
            Back to Shop
          </button>
        </div>
        <div className="flex items-center justify-center gap-1 font-mono text-[9px] text-slate-600 mt-5">
          <Lock className="w-3 h-3" /> NO CHARGE WAS MADE
        </div>
      </div>
    </div>
  );
}
